import React from 'react';
import Head from 'next/head';
import { Box, Container } from '@mui/material';
import BaseLayout from 'layouts/BaseLayout';
import Header from 'components/Feedback/Header';
import List from 'components/Feedback/List';
import { COLOR_PURPLE_HOVER, COLOR_WHITE } from 'styles/variables/colors';
import useIsMobile from 'hooks/useIsMobile';

export default function FeedbacksPage() {
  const isMobile = useIsMobile();

  return (
    <BaseLayout
      bgBrandColor={!isMobile ? COLOR_WHITE : COLOR_PURPLE_HOVER}
      headerWhite={true}
      typeBtn="buttonSecondary"
      hasPadding={false}
    >
      <Head>
        <title>Feedbacks - Mind The Graph</title>
      </Head>

      <Container>
        <Box pt={8} pb={4}>
          <Header />
        </Box>

        <Box py={4}>
          <List />
        </Box>
      </Container>
    </BaseLayout>
  );
}
